import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const FooterSocialLinks = () => (
  <div className="flex gap-6">
    <button
      type="button"
      className="transition-colors hover:text-white/80"
      style={{ color: 'rgba(255, 255, 255, 0.5)' }}
      aria-label="Facebook"
    >
      <Facebook size={20} />
    </button>
    <button
      type="button"
      className="transition-colors hover:text-white/80"
      style={{ color: 'rgba(255, 255, 255, 0.5)' }}
      aria-label="Twitter"
    >
      <Twitter size={20} />
    </button>
    <button
      type="button"
      className="transition-colors hover:text-white/80"
      style={{ color: 'rgba(255, 255, 255, 0.5)' }}
      aria-label="Instagram"
    >
      <Instagram size={20} />
    </button>
    <button
      type="button"
      className="transition-colors hover:text-white/80"
      style={{ color: 'rgba(255, 255, 255, 0.5)' }}
      aria-label="LinkedIn"
    >
      <Linkedin size={20} />
    </button>
  </div>
);

export default FooterSocialLinks;
